import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from 'react-redux';

import PublicPageLayout from "layouts/public";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import MyPageLayout from "layouts/my";
import { useLocation } from "react-router-dom";
import CrudHandler from "components/crudhandler";
import Error404 from "views/error/error404";
import { theme } from 'theme';
import { ConfigProvider } from 'antd';

const App = ({auth, pageTitle}) => {

	const location = useLocation();
  	const targetLocation = location.pathname;  	

  	return (
		<ConfigProvider theme={theme}>
	  	<CrudHandler />
	    <Routes>
			{auth.isLoggedIn && <Route path="/auth/sign-in" element={<Navigate to="/my/profile" />} />}    
	        {auth.isLoggedIn ? (
			<>
	          	<Route path="/" element={<Navigate to={targetLocation !== '/' ? targetLocation : '/my/profile'} />} replace/>
	          	<Route path="admin/*" element={<AdminLayout />} />
				<Route path="/*" element={<MyPageLayout />}></Route>
				<Route path="*" element={<Error404 />} />
        	</>
	      	) : (
			<>
				<Route path="/" element={<Navigate to="/job-posts" replace />} />
				<Route path="/*" element={<PublicPageLayout />} />
				<Route path="*" element={<Error404 />} />
			</>
	      	)}
	    </Routes>
      </ConfigProvider>
  	);
};

const mapStateToProps = (state) => ({
	auth: state.auth,	
  });
  
const mapDispatchToProps = (dispatch) => ({

});
  
  
export default connect(mapStateToProps, mapDispatchToProps)(App);
